export default function(StateManager, newsService) {
	return class NewsDetails extends StateManager {
		request(props) {
			return newsService.fetchDetails({ id: props.match.params.id });
		}
	};
}
